// Types
export type { NodeConfiguration, RegisteredNode, NodeCategory } from './types';

// Event Node
export { EventNode, eventConfig } from './nodes/event';
export type { EventNodeData, EventNodeProps } from './nodes/event';

// Import for internal use
import { EventNode } from './nodes/event';
import { eventConfig } from './nodes/event';

// Node registry helpers
export const nodes = {
  event: {
    component: EventNode,
    config: eventConfig,
  },
};

export const nodeConfigs = {
  event: eventConfig,
};

export const nodeComponents = {
  event: EventNode,
};